<template>
  <main class="main create_estimate_common" role="main" v-if="isCompleted">
    <div class="main_con">
      <!-- <div class="step">
        <div class="point on"></div>
        <div class="step_txt">Step1. 견적요청</div>
      </div> -->
      <!-- https://webclub.tistory.com/539 -->
      <div class="step_bar">
        <div class="bar">
          <div class="state" :style="{ width: `${widthLine}%` }"></div>
        </div>
      </div>
      <!--
        인터넷 견적서 보내기
        STEP 1. 가입유형 선택
        STEP 2. 동네 선택
        STEP 3. 통신사 선택
        STEP 4. 상품 선택
        STEP 5. 인터넷 속도 선택 (mode == '')
        STEP 6. 인터넷 통신사 선택 (가입유형이 변경일때만, mode == '')
        STEP 7. 휴대폰 개통여부 선택
        STEP 8. 견적 정보 확인
      -->

      <!-- STEP 1 -->
      <div class="step_qa" v-if="isCurStep == 1">
        <div class="question">
          희망하는 가입유형을<br />
          알려주세요.
        </div>
        <div
          class="answer_wrap check_table"
          v-if="
            isMode == 'MY_INTERNET' &&
              internetProduct.telecomId != 'LGUPLUS' &&
              internetProduct.telecomId != 'KT'
          "
        >
          <label v-for="(item, index) in joinTypes.slice(0, 1)" :key="index"
            ><input
              type="radio"
              v-model="internetInfo.joinType"
              name="ic_1"
              :value="item.value"
              @change="goNext"
            />
            <div class="txt"></div>
            <div class="txt02">{{ item.label }}</div>
          </label>

          <div class="sk_info">
            KT와 LGU+ 이외의 나머지 통신사의 경우<br />
            재약정에 대한 혜택이 없어요!<br />
            통신사 이동을 통해 다양한 혜택을 받아보는건 어떠신가요?
          </div>
        </div>
        <div class="answer_wrap check_table" v-else>
          <label v-for="(item, index) in joinTypes" :key="index"
            ><input
              type="radio"
              v-model="internetInfo.joinType"
              name="ic_1"
              :value="item.value"
              @change="internetRequestNotice"
            />
            <div class="txt"></div>
            <div class="txt02">{{ item.label }}</div>
          </label>
        </div>
      </div>

      <!-- STEP 2 -->
      <div class="step_qa" v-if="isCurStep == 2">
        <div class="question">
          인터넷 설치하실 동네를 선택해 주세요!
        </div>
        <div class="answer_wrap" data-columns="">
          <label class="area select" @click="goSelectArea">
            <button>
              선택 주소 : {{ areaInfo.name }}<span class="i_drop"></span>
            </button>
          </label>
        </div>
        <div class="question_sub">
          설치하실 장소의 유형이 어떻게 되나요?
        </div>
        <div class="answer_wrap check_table answer_wrap_sub">
          <label
            v-for="(item, index) in areaTypes"
            :key="index"
            class="answer_half"
            ><input
              type="radio"
              v-model="internetInfo.areaType"
              name="ic_1_1"
              :value="item.value"
              @change="goNext()"
            />
            <div class="txt"></div>
            <div class="txt02">
              {{ item.label }}
            </div>
          </label>
        </div>
      </div>

      <!-- STEP 3 -->
      <div class="step_qa" v-if="isCurStep == 3">
        <div class="question" v-if="formType == 'A'">
          가입(신규,변경)을 희망하는 통신사는 어디신가요?
        </div>
        <div class="question" v-else>
          현재 이용중인<br />통신사는 어디인가요?
        </div>
        <div class="answer_wrap check_table">
          <!-- 추천 -->
          <label v-if="formType == 'A'"
            ><input
              type="radio"
              v-model="internetInfo.telecom"
              name="ic_2"
              value="추천"
              @change="goNext()"
            />
            <div class="txt"></div>
            <div class="txt02">
              통신사 상관없이 혜택 좋은 곳
            </div>
          </label>
          <!-- 기본 텔레콤 -->
          <label v-for="item in telecoms" :key="item.value"
            ><input
              type="radio"
              v-model="internetInfo.telecom"
              name="ic_2"
              :value="item.value"
              @change="goNext()"
            />
            <div class="txt"></div>
            <div class="txt02">
              {{ item.label }}
            </div>
          </label>
          <!-- 우리동네 케이블 -->
          <label v-for="item in cableList" :key="item.value"
            ><input
              type="radio"
              v-model="internetInfo.telecom"
              name="ic_2"
              :value="item.value"
              @change="goNext()"
            />
            <div class="txt"></div>
            <div class="txt02">
              <p style="font-size: 1.2rem; color: grey">
                우리동네 케이블 방송 :
              </p>
              {{ item.label }}
            </div>
          </label>
          <div class="sk_info" v-if="formType == 'B'">
            KT와 LGU+ 이외의 나머지 통신사의 경우<br />
            재약정에 대한 혜택이 없어요!<br />
            통신사 이동을 통해 다양한 혜택을 받아보는건 어떠신가요?
          </div>
        </div>
      </div>

      <!-- STEP 4 -->
      <div class="step_qa" v-if="isCurStep == 4">
        <div class="question">
          이용하실 상품은<br />
          무엇인가요?
        </div>
        <div class="answer_wrap check_table">
          <label v-for="item in useItems" :key="item.value"
            ><input
              type="radio"
              v-model="internetInfo.itemUse"
              name="ic_2"
              :value="item.value"
              @change="goNext()"
            />
            <div class="txt"></div>
            <div class="txt02">{{ item.label }}</div>
          </label>
          <!-- <div class="ans_info">
            * 집전화 또는 인터넷전화는 별도 상담하시기 바랍니다.
          </div> -->
        </div>
      </div>

      <!-- STEP 5 -->
      <div class="step_qa" v-if="isCurStep == 5">
        <div class="question">
          원하시는 인터넷 속도를 선택해주세요.
        </div>
        <div class="answer_wrap check_table">
          <label v-for="item in speedList" :key="item.value"
            ><input
              type="radio"
              v-model="internetInfo.speed"
              name="ic_5"
              :value="item.value"
              @change="goNext()"
            />
            <div class="txt"></div>
            <div class="txt02">
              {{ item.value }}
              <p>{{ item.desc }}</p>
            </div>
          </label>
        </div>
      </div>

      <!-- STEP 6 (인터넷 가입만) -->
      <div class="step_qa" v-if="isCurStep === 6 && formType === 'A'">
        <div class="question">
          현재 이용 중인 인터넷 통신사는 어디인가요?
        </div>
        <div class="answer_wrap check_table">
          <label v-for="item in currentTelecoms" :key="item.value"
            ><input
              type="radio"
              v-model="internetInfo.currentTelecom"
              name="ic_2"
              :value="item.value"
              @change="goNext()"
            />
            <div class="txt"></div>
            <div class="txt02">
              {{ item.label }}
              <p>{{ item.subLabel }}</p>
            </div>
          </label>
        </div>
      </div>

      <!-- STEP 7 -->
      <div class="step_qa" v-if="isCurStep === 7">
        <div class="question">
          모바일도<span class="q_small_txt">(USIM 또는 휴대폰)</span><br />
          같이 개통할 의향이 있나요?
          <div class="q_info_txt">
            쓰던폰 그대로 모바일 유심만 추가 개통하더라도
            <span>더 많은 혜택</span>을 받을 수 있습니다
          </div>
        </div>
        <div class="answer_wrap check_table">
          <label v-for="item in phoneJoinTypes" :key="item.value"
            ><input
              type="radio"
              v-model="internetInfo.phoneJoin"
              name="ic_2"
              :value="item.value"
              @change="goNext()"
            />
            <div class="txt"></div>
            <div class="txt02">{{ item.label }}</div>
          </label>
        </div>
      </div>

      <!-- STEP 8 -->
      <div class="e_step_qa" v-if="isCurStep == 8">
        <div class="question">
          입력하신 정보가 맞다면,<br />이제 견적을 받아볼까요?
        </div>
        <div class="result_wrap" :class="{ skylife: isMode == 'MY_INTERNET' }">
          <div class="result_inner">
            <div class="list">
              <div class="txt">개통구분</div>
              <div class="txt02">{{ internetInfo.joinType }}</div>
            </div>
            <div class="list">
              <div class="txt">상품구성</div>
              <div class="txt02">
                {{ internetInfo.speed }} {{ internetInfo.itemUse
                }}{{ getPhoneJoin(internetInfo.phoneJoin) }}
              </div>
            </div>
            <div class="list">
              <div class="txt">희망통신사</div>
              <div class="txt02">
                {{ formType == 'A' ? internetInfo.telecom + ' 희망' : '-' }}
              </div>
            </div>
            <div class="list">
              <div class="txt">기존통신사</div>
              <div class="txt02">
                {{
                  formType == 'A'
                    ? internetInfo.currentTelecom
                    : internetInfo.telecom
                }}
              </div>
            </div>
            <div class="list">
              <div class="txt">설치지역</div>
              <div class="txt02">
                {{ areaInfo.fullName }} {{ getAreaType(internetInfo.areaType) }}
              </div>
            </div>
          </div>
          <div
            class="result_inner"
            style="margin-top: 1rem"
            v-if="isMode == 'MY_INTERNET'"
          >
            <div class="list">
              <div class="txt">상품구성</div>
              <div class="txt02" v-html="internetInfo.itemCompose"></div>
            </div>
            <div class="list">
              <div class="txt">월 요금</div>
              <div class="txt02">
                {{ internetProduct.realPrice | comma }}원
                <p>{{ isDesc() }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 안내사항 -->
    <div class="btm_form_info ic" v-if="isCurStep == 8">
      <div class="info_img">
        <img
          :src="require('@/assets/front/images/new/img_txt_noti_hand.png')"
          alt=""
        />
      </div>
      <div class="info_txt">
        <div>견적 요청 후 일주일간 수정 및 재등록이 불가합니다!</div>
        <div><span>상담 중 직거래 요청에 주의</span>하세요!</div>
        <div>분쟁시 퍼스의 도움을 받을 수 없어요!</div>
      </div>
    </div>

    <!-- 이전버튼 -->
    <div
      class="ic_back"
      v-if="isCurStep != 1 && isCurStep != 8"
      @click="goPrev()"
    >
      <img
        :src="require(`@/assets/front/images/mobile/ic_float_pre.svg`)"
        alt=""
      />
    </div>

    <!-- 다음버튼 (동네선택시만) -->
    <!-- <div class="ic_next" v-if="isCurStep == 2" @click="goNext()">
      다음
      <img
        :src="require(`@/assets/front/images/mobile/ic_float_nxt_w.svg`)"
        alt=""
      />
    </div> -->

    <div class="btm_btn" v-if="isCurStep == 8">
      <div class="btn_wrap">
        <button class="btn bo" @click="goPrev()">
          뒤로가기
        </button>
        <button @click="sendInternet" class="btn">
          견적 요청하기
        </button>
      </div>
    </div>
    <DesignPopup2
      :show="designPopup"
      :data="{
        title: '견적 받아보기 안내',
        type: 'confirm',
        msg: `전국 매장에 견적을 요청할게요!<br />답변하신 내용을 바탕으로<br />매장들이 보내준 혜택을 한눈에 비교할 수 있어요!<br /><br />🔔진행 상황은 카카오톡 알림으로 바로 알려드려요.`,
      }"
      @close="popupClose"
    />
    <InternetRequestNoticeModal
      :show="isShowRequestNoticeView"
      @close="closeShowRequestNoticeView"
      @joinTypeSel="joinTypeSel"
    />
  </main>
</template>

<script>
import * as util from '@common/lib/common/utils.js';
import DesignPopup2 from '@/common/components/modal/DesignPopup2';
import format from 'date-fns/format';
import cableStation from '@common/lib/common/cableStation';

import {
  mapActions as userMapActions,
  mapGetters as userMapGetters,
} from '@common/store/modules/user';
import * as userTypes from '@common/store/modules/user/types';

import {
  mapActions as internetMapActions,
  mapGetters as internetMapGetters,
} from '@common/store/modules/internet';
import * as internetTypes from '@common/store/modules/internet/types';

import InternetRequestNoticeModal from '@/front/customer/views/internetCommerce/modal/InternetRequestNoticeModal.vue';

export default {
  components: {
    DesignPopup2,
    InternetRequestNoticeModal,
  },
  filters: {
    comma(val) {
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
  },
  data() {
    return {
      designPopup: false,
      isCompleted: false,
      isCurStep: 1,
      isCurrentTelecom: '', // 가입, 가입통신사 일 경우 이용중인 통신사에서 제거
      errorMessage: '',
      widthLine: 12,
      areaInfo: {
        area1: '', // 시, 도
        area2: '', // 구, 군
        name: '',
        fullName: '',
      },
      formType: '',
      internetInfo: {
        joinType: '',
        areaType: '',
        telecom: '',
        itemUse: '',
        speed: '',
        phoneJoin: '',
        currentTelecom: '',
        itemCompose: '',
      },
      joinTypes: [
        { label: '인터넷 가입(신규,변경)', value: '가입(신규,변경)' },
        { label: '인터넷 연장(재약정)', value: '연장(재약정)' },
      ],
      areaTypes: [
        { label: '아파트', value: 'APT' },
        { label: '빌라, 주택 등', value: 'HOUSE' },
        { label: '사무실', value: 'OFFICE' },
        { label: '영업매장', value: 'SHOP' },
      ],
      currentTelecoms: [
        { label: 'SKT', value: 'SKT' },
        { label: 'KT', value: 'KT' },
        { label: 'LGU+', value: 'LGU+' },
        { label: 'KT Skylife', value: 'KT Skylife' },
        { label: '우리동네 케이블 방송', value: '케이블 방송' },
        { label: '이용안함(신규가입)', value: '이용안함' },
        { label: '모르겠음', value: '모르겠음' },
      ],
      phoneJoinTypes: [
        { label: '아니오, 모바일 개통 의향 없음', value: 'NONE' },
        { label: '네, 모바일 유심 개통 의향 있음', value: 'USIM' },
        { label: '네, 휴대폰 개통 의향 있음', value: 'PHONE' },
      ],
      cableList: [],
      useItems: [],
      speedList: [],
      isMode: '',
      internetProduct: [],
      isShowRequestNoticeView: false,
      sleepCheck: true,
    };
  },
  async created() {
    // MY_INTERNET, ''
    this.isMode = this.$route.query.mode;

    if (this.isMode == 'MY_INTERNET') {
      await this.getInternetProduct();
    }

    await this.getInternetCommerceIngList();
    await this.getInternetCommerceEndList();

    let goCreateCheck = true;
    const now = format(new Date(), 'yyyy-MM-dd HH:mm:ss');

    // 인터넷 견적을 생성한지 일주일이 지나야만 재요청이 가능하다 (최대 2건)
    if (this.internetCommerceIngList.content.length >= 2) {
      goCreateCheck = false;
    } else if (this.internetCommerceIngList.content.length == 1) {
      if (this.internetCommerceEndList.content.length >= 1) {
        const createdAt = new Date(
          this.internetCommerceEndList.content[0].createdAt,
        );

        const sDays = format(
          new Date(createdAt.setDate(createdAt.getDate() + 7)),
          'yyyy-MM-dd HH:mm:ss',
        );

        // 안지났음
        if (now < sDays) {
          goCreateCheck = false;
        } else {
          goCreateCheck = true;
        }
      } else {
        goCreateCheck = true;
      }
    } else if (this.internetCommerceIngList.content.length == 0) {
      if (this.internetCommerceEndList.content.length >= 2) {
        const createdAt_1 = new Date(
          this.internetCommerceEndList.content[0].createdAt,
        );

        const sDays_1 = format(
          new Date(createdAt_1.setDate(createdAt_1.getDate() + 7)),
          'yyyy-MM-dd HH:mm:ss',
        );

        const createdAt_2 = new Date(
          this.internetCommerceEndList.content[1].createdAt,
        );

        const sDays_2 = format(
          new Date(createdAt_2.setDate(createdAt_2.getDate() + 7)),
          'yyyy-MM-dd HH:mm:ss',
        );

        // 둘다 안지났음
        if (now < sDays_1 && now < sDays_2) {
          goCreateCheck = false;
        } else {
          goCreateCheck = true;
        }
      } else {
        goCreateCheck = true;
      }
    } else {
      goCreateCheck = true;
    }

    if (!goCreateCheck) {
      this.$router.push({ path: '/' }).catch(err => {});
    }

    await this.getMyProfile();

    // 동네매장 페이지 이동 후 값 전달
    await this.getInternetInfo();
    this.isCompleted = true;
  },
  computed: {
    ...userMapGetters({
      user: userTypes.USER,
    }),
    ...internetMapGetters({
      internetCommerceIngList: internetTypes.INTERNET_COMMERCE_ING_LIST,
      internetCommerceEndList: internetTypes.INTERNET_COMMERCE_END_LIST,
    }),
    telecoms() {
      let list = [];
      if (this.formType === 'A')
        list.push({ label: 'SKT/SKB', value: 'SKT/SKB' });
      list.push({ label: 'KT', value: 'KT' }, { label: 'LGU+', value: 'LGU+' });
      if (this.formType === 'A')
        list.push({ label: 'KT Skylife', value: 'KT Skylife' });
      return list;
    },
  },
  methods: {
    ...userMapActions([userTypes.FETCH_ME]),
    ...internetMapActions([
      internetTypes.CREATE_INTERNET_COMMERCE_ESTIMATION,
      internetTypes.SELECT_INTERNET_COMMERCE_ESTIMATION,
    ]),
    async getInternetProduct() {
      let internetProductSelect = localStorage.getItem('internetProductSelect');
      if (!internetProductSelect) {
        this.internetProduct = new Array();
      } else {
        this.internetProduct = JSON.parse(internetProductSelect);
      }

      console.log('this.internetProduct');
      console.log(this.internetProduct);
    },
    async getMyProfile() {
      await this[userTypes.FETCH_ME]();
    },
    async getInternetInfo() {
      const internetEstimateStep = localStorage.getItem('internetEstimateStep');
      const internetEstimateFormType = localStorage.getItem(
        'internetEstimateFormType',
      );
      let internetArea = localStorage.getItem('internetArea');
      let internetEstimate = localStorage.getItem('internetEstimate');

      // 동네 선택 후 기존 값 넣어주기
      if (internetEstimateStep == 2) {
        this.formType = internetEstimateFormType;
        this.isCurStep = 2;
        if (internetEstimate) {
          this.internetInfo = JSON.parse(internetEstimate);
        }
      } else {
        localStorage.removeItem(`internetArea`);
        localStorage.removeItem(`internetEstimate`);
        localStorage.removeItem(`internetEstimateFormType`);
        localStorage.removeItem(`internetEstimateStep`);
        this.isCurStep = 1;
      }

      if (internetArea) {
        internetArea = JSON.parse(internetArea);
        this.areaInfo.name = internetArea.areaName;
        this.areaInfo.fullName = internetArea.areaFullName;
      } else {
        this.areaInfo.name = this.user.emdAreaNameShort;
        this.areaInfo.fullName = this.user.emdAreaName;
      }
    },
    updateStatus(isNext) {
      /**
       *  'FORMTYPE A': 12 > 24 > 36 > 48 > 60 > 72 > 84 > 100
       *  'FORMTYPE B': 14 > 28 > 42 > 56 > 70 >  84 > 100
       */
      let totalStep = this.formType === 'A' ? 8 : 7;

      if (this.isMode == 'MY_INTERNET') {
        totalStep = this.formType === 'A' ? 5 : 4;
      }
      const width = Math.floor(100 / totalStep);
      if (isNext) {
        if (this.isCurStep === 1 && this.formType === 'B') {
          this.widthLine = 14;
        }

        this.widthLine += width;

        if (this.isCurStep === 7) this.widthLine = 100;
      } else {
        if (this.isCurStep === 7) {
          if (this.formType === 'A') this.widthLine = 96;
          else this.widthLine = 98;
        }

        this.widthLine -= width;
      }
    },
    goPrev() {
      this.isCurStep--;

      console.log(this.isCurStep);
      console.log(this.internetInfo.joinType);
      console.log('isCurStep ==== ' + this.isCurStep);

      if (this.isCurStep === 6 && this.formType === 'B') {
        this.isCurStep -= 1;
      }

      if (this.isCurStep === 1) {
        delete this.internetInfo.joinType;
      }
      if (this.isCurStep === 2) {
        this.cableList = [];
        delete this.internetInfo.areaType;
      }
      if (this.isCurStep === 3) {
        this.useItems = [];
        delete this.internetInfo.telecom;
      }
      if (this.isCurStep === 4) {
        this.speedList = [];
        delete this.internetInfo.itemUse;
      }
      if (this.isCurStep === 5) {
        delete this.internetInfo.speed;

        if (this.isMode == 'MY_INTERNET') {
          if (this.formType == 'A') {
            this.isCurStep -= 3;
          } else if (this.formType == 'B') {
            this.isCurStep -= 3;
          }
        }
      }
      if (this.isCurStep === 6) {
        delete this.internetInfo.currentTelecom;
      }
      if (this.isCurStep === 7) {
        this.internetInfo.phoneJoin = '';
        localStorage.removeItem(`internetEstimate`);
        if (this.internetInfo.telecom) {
          if (this.isMode != 'MY_INTERNET') {
            const telecom = ['SKT/SKB', 'KT', 'LGU+', '추천'];
            if (!telecom.includes(this.internetInfo.telecom)) {
              this.isCurStep -= 1;
              delete this.internetInfo.currentTelecom;
            }
          }
        }
      }
      this.updateStatus(false);

      console.log('isCurStep = ' + this.isCurStep);

      localStorage.setItem('internetEstimateStep', this.isCurStep);
      localStorage.setItem('internetEstimateFormType', this.formType);
      localStorage.setItem(
        `internetEstimate`,
        JSON.stringify(this.internetInfo),
      );
    },
    internetRequestNotice() {
      if (this.isCurStep === 1) {
        if (this.internetInfo.joinType == '가입(신규,변경)') {
          this.goNext();
        } else {
          // 재약정 선택시 팝업
          this.isShowRequestNoticeView = true;
        }
      }
    },
    async goNext() {
      let stepCnt = 0;
      this.sleepCheck = true;
      if (this.isCurStep === 1) {
        if (this.internetInfo.joinType == '가입(신규,변경)') {
          this.formType = 'A';
        } else {
          // 재약정 선택시 팝업
          this.formType = 'B';
        }
      } else if (this.isCurStep === 2) {
        this.searchCableStation();
        if (this.isMode == 'MY_INTERNET') {
          if (this.formType == 'A') {
            this.isCurStep += 3;
          } else if (this.formType == 'B') {
            this.isCurStep += 4;
          }
          this.internetInfo.telecom = this.internetProduct.telecomName;
        }
      } else if (this.isCurStep === 3) {
        this.searchUseItem();
      } else if (this.isCurStep === 4) {
        this.searchInternetSpeed();
      } else if (this.isCurStep === 5) {
        if (this.formType === 'B') {
          console.log(1);
          // this.isCurStep += 1;
          stepCnt++;
          if (this.internetInfo.telecom) {
            console.log(2);
            if (this.isMode != 'MY_INTERNET') {
              console.log(3);
              const telecom = ['SKT/SKB', 'KT', 'LGU+', '추천'];
              if (!telecom.includes(this.internetInfo.telecom)) {
                console.log(4);
                this.isCurStep += 1;
              }
            }
          }
        }
      } else if (this.isCurStep === 6) {
        if (this.internetInfo.telecom) {
          if (this.isMode != 'MY_INTERNET') {
            const telecom = ['SKT/SKB', 'KT', 'LGU+', '추천'];
            if (!telecom.includes(this.internetInfo.telecom)) {
              this.isCurStep += 1;
              this.sleepCheck = false;
            }
          }
        }
      }

      if (this.isMode == 'MY_INTERNET') {
        if (!this.internetInfo.telecom) {
          this.internetInfo.telecom = this.internetProduct.telecomName;
        }

        if (!this.internetInfo.speed) {
          this.internetInfo.speed = this.isInternetSpeed(
            this.internetProduct.internetSpeed,
          );
        }

        if (!this.internetInfo.itemUse) {
          let itemCompose = '';
          let itemUse = '';

          if (this.internetProduct.internetId || this.internetProduct.wifiId) {
            itemCompose = '[인터넷] ';
            itemCompose += this.internetProduct.internetName;

            if (
              this.internetProduct.internetId &&
              this.internetProduct.wifiId
            ) {
              itemCompose += '+' + this.internetProduct.wifiName;
            }

            if (this.internetProduct.internetId) {
              itemUse += '인터넷';
            }
          }

          if (this.internetProduct.tvId || this.internetProduct.settopId) {
            itemCompose += '<br/>';
            itemCompose += '[TV] ';
            itemCompose += this.internetProduct.tvName;

            if (this.internetProduct.tvId && this.internetProduct.settopId) {
              itemCompose += '+' + this.internetProduct.settopName;
            }

            if (this.internetProduct.internetId) {
              itemUse += '+';
            }
            if (this.internetProduct.tvId) {
              itemUse += 'TV';
            }
          }

          this.internetInfo.itemCompose = itemCompose;
          this.internetInfo.itemUse = itemUse;
        }
      }

      // 0.2초 시간을 줘야 다음 단계에서 radio 자동선택이 안됨.
      if (this.sleepCheck) {
        await util.sleep(200);
      }

      this.updateStatus(true);
      if (stepCnt > 0) {
        this.isCurStep += stepCnt;
      }

      this.isCurStep++;

      localStorage.setItem('internetEstimateStep', this.isCurStep);
      localStorage.setItem('internetEstimateFormType', this.formType);
      localStorage.setItem(
        `internetEstimate`,
        JSON.stringify(this.internetInfo),
      );

      console.log('isCurStep = ' + this.isCurStep);
      console.log('formType = ' + this.formType);
      console.log(this.internetInfo);
    },
    isInternetSpeed(internetSpeed) {
      console.log('internetSpeed = ' + internetSpeed);
      if (internetSpeed >= 1000) {
        let internetSpeedFormat = internetSpeed / 1000;

        return internetSpeedFormat + 'G';
      } else {
        return internetSpeed + 'M';
      }
      // const internetS = 1600;
      // console.log('asdfsdf');
      // console.log(internetS / 1000);
    },
    searchCableStation() {
      if (this.formType == 'A') {
        const fullName = this.areaInfo.fullName.split(' ');
        const si = fullName[0].trim();
        const gu = fullName[1].trim();

        this.cableList = cableStation.search(si, gu);
      }
    },
    searchUseItem() {
      this.useItems.push(
        { label: '인터넷', value: '인터넷' },
        { label: '인터넷 + TV', value: '인터넷+TV' },
      );
      const telecom = ['SKT/SKB', 'KT', 'LGU+', '추천'];
      if (telecom.includes(this.internetInfo.telecom)) {
        this.useItems.push(
          { label: '인터넷 + 전화', value: '인터넷+전화' },
          { label: '인터넷 + TV + 전화', value: '인터넷+TV+전화' },
        );
      }
    },
    searchInternetSpeed() {
      let list = ['100M', '500M', '1G'];

      const telecom = ['SKT/SKB', 'KT', 'LGU+', 'KT Skylife'];
      if (!telecom.includes(this.internetInfo.telecom)) {
        const station = this.internetInfo.telecom.split(' ')[0];
        list = cableStation.getInternetSpeed(station);
      } else {
        if (this.internetInfo.telecom == 'KT Skylife') {
          list = ['100M', '200M', '500M', '1G'];
        }
      }

      list.forEach(item => {
        if (item === '100M') {
          this.speedList.push({
            value: '100M',
            // desc: '(간단한 웹 서핑, 문서 작업에 추천)',
          });
        }
        if (item === '160M' || item === '200M' || item === '320M') {
          this.speedList.push({
            value: item,
            // desc: '(웹서핑, 게임, 영상 시청에 추천)',
          });
        }
        if (item === '500M') {
          this.speedList.push({
            value: '500M',
            // desc: '(게임, 고화질 영상 시청에 추천)',
          });
        }
        if (item === '1G') {
          this.speedList.push({
            value: '1G',
            // desc: '(개인방송, 다수이용, 대용량 파일 업로드에 추천)',
          });
        }
      });
    },
    goSelectArea() {
      if (this.user.emdAreaName != null) {
        let codeType = 'e';
        let areaId = this.user.emdAreaId;
        if (this.user.admName) {
          const admArea = JSON.parse(this.user.admName);
          areaId = admArea.id;
          codeType = 'a';
        }
        this.$router.push({
          name: 'Auth.RegionSelected',
          query: {
            areaName: this.user.emdAreaName.substring(
              this.user.emdAreaName.lastIndexOf(' ') + 1,
            ),
            areaFullName: this.user.emdAreaName,
            areaId,
            codeType,
            from: this.isMode == 'MY_INTERNET' ? 'MyInternet' : 'Internet',
          },
        });
      } else {
        this.$router.push({
          name: 'Auth.Region',
          query: { from: 'Internet', isAreaValue: 'No' },
        });
      }
    },
    sendInternet() {
      this.designPopup = true;
    },
    popupClose(checked) {
      if (checked) {
        let params = { ...this.internetInfo };

        params.areaFullName = this.areaInfo.fullName;
        params.areaName = this.areaInfo.name;
        params.userId = this.user.id;

        // 인터넷 연장(재약정)일 경우
        if (this.formType === 'B') {
          // params.telecom = '';
          params.currentTelecom = this.internetInfo.telecom;
        }

        if (this.isMode == 'MY_INTERNET') {
          params.internetName = this.internetProduct.internetName;
          params.wifiName = this.internetProduct.wifiName;
          params.tvName = this.internetProduct.tvName;
          params.settopName = this.internetProduct.settopName;
          params.realPrice = this.internetProduct.realPrice;
          params.installCost = this.internetProduct.installCost;
          params.installCostWeekend = this.internetProduct.installCostWeekend;
          params.promotionCode = this.isMode;
        }

        console.log('params....');
        console.log(params);

        this[internetTypes.CREATE_INTERNET_COMMERCE_ESTIMATION](params).then(
          () => {
            util.sdk_logEvent('INTERNET_ESTIMATE', {
              user_id: this.user.id,
            });

            util.sdk_logEventKakao('INTERNET_ESTIMATE');

            this.designPopup = false;

            localStorage.removeItem(`internetArea`);
            localStorage.removeItem(`internetEstimate`);
            localStorage.removeItem(`internetEstimateFormType`);
            localStorage.removeItem(`internetEstimateStep`);

            // 페이지 이동
            this.$router.push({
              name: 'InternetCommerce.List',
            });
          },
        );
      }

      this.designPopup = false;
    },
    async getInternetCommerceIngList() {
      await this[internetTypes.SELECT_INTERNET_COMMERCE_ESTIMATION]({
        page: 1,
        size: 10,
        status: 'ING',
        orderType: 'CREATED_AT_DESC',
      });
    },
    async getInternetCommerceEndList() {
      await this[internetTypes.SELECT_INTERNET_COMMERCE_ESTIMATION]({
        page: 1,
        size: 10,
        status: 'END',
        orderType: 'CREATED_AT_DESC',
      });
    },
    isDesc() {
      let desc = '(부가세 포함, ';

      if (
        (this.internetProduct.telecomId === 'KT' ||
          this.internetProduct.telecomId === 'SKYLIFE') &&
        this.internetProduct.installCost !==
          this.internetProduct.installCostWeekend
      ) {
        desc +=
          '설치비 주중 : ' +
          this.formatNumber(this.internetProduct.installCost) +
          '원, 주말 : ' +
          this.formatNumber(this.internetProduct.installCostWeekend) +
          '원)';
      } else {
        desc +=
          '설치비 ' +
          this.formatNumber(this.internetProduct.installCost) +
          '원)';
      }
      return desc;
    },
    formatNumber(val) {
      return util.toCurrency(val);
    },
    closeShowRequestNoticeView() {
      this.isShowRequestNoticeView = false;
      delete this.internetInfo.joinType;
    },
    joinTypeSel(sel) {
      if (sel == 'A') {
        this.internetInfo.joinType = this.joinTypes[0].value;
      } else if (sel == 'B') {
        this.internetInfo.joinType = this.joinTypes[1].value;
      }

      this.isShowRequestNoticeView = false;
      this.goNext();
    },
    getAreaType(area) {
      if (!area || area == null) {
        return '';
      }
      const foundInfo = this.areaTypes.filter(info => info.value === area);

      if (foundInfo[0].label) {
        return ' | ' + foundInfo[0].label;
      }
      return '';
    },
    getPhoneJoin(phoneJoin) {
      if (phoneJoin == 'PHONE') {
        return '+휴대폰';
      } else if (phoneJoin == 'USIM') {
        return '+USIM';
      } else {
        return '';
      }
    },
  },
};
</script>
